import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const defaultTheme = createTheme();

const useThankyouPageStyle = makeStyles((theme) => {
  const activeTheme = theme?.breakpoints ? theme : defaultTheme;
  return {
    container: {
      width: "50%",
      margin: "5rem auto",
      textAlign: "center",
      padding: "20px",
      [activeTheme.breakpoints.down("md")]: {
        width: "75%",
        margin: "3rem auto",
      },
      [activeTheme.breakpoints.down("sm")]: {
        width: "95%",
        margin: "2rem auto",
        padding: "10px",
      },
      "& .MuiTypography-h3": {
        fontSize: "2rem",
        color: "#303030",
        fontWeight: "bold",
        [activeTheme.breakpoints.down("sm")]: {
          fontSize: "1.4rem",
        },
      },
      "& .MuiListItemIcon-root": {
        minWidth: "30px",
      },
      "& .MuiTypography-body1": {
        color: "#2D2C2C",
        fontSize: "1.025rem",
        [activeTheme.breakpoints.down("sm")]: {
          fontSize: "0.9rem",
        },
      },
      "& .MuiList-root": {
        width: "85%",
        margin: "0 auto",
        [activeTheme.breakpoints.down("sm")]: {
          width: "100%",
        },
      },
    },
    heading: {
      width: "90%",
      margin: "1rem auto",
      [activeTheme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    imageContainer: {
        "& img": {
            maxWidth: "150px",
            width: "100%",
            height: "auto",
            [activeTheme.breakpoints.down("sm")]: {
                maxWidth: "100px",
            },
        },
    },
    instructionContainer: {
      marginTop: "1.5rem",
      padding: "1rem",
      background: "#F4F7FF",
      borderRadius: "8px",
    },
  };
});
  
export default useThankyouPageStyle;
